var surveyUtils = (function() {

    var _getSurveyId = function(history, index) {
        return history.index[index];
    };

    var _getSequenceLength = function(surveys, surveyId) {
        return surveys[surveyId].sequence.length;
    };

    var _getSequenceId = function(surveys, surveyId, index) {
        return surveys[surveyId] ? surveys[surveyId].sequence[index] : '';
    };

    var _getCurrentSequence = function(sequences, sequenceId) {
        return sequences[sequenceId];
    };

    var _getCurrentField = function(fields, fieldName) {
        return fields[fieldName] || {};
    };

    var _getFieldNavigation = function(fields, fieldName) {
        return fields[fieldName].navigation;
    };

    var _getNextSurveyIndex = function(history) {
        return history.currentSurveyIndex + 1;
    };

    var _getSurveysLength = function(surveys) {
        return surveys.length;
    };

    var _getPriorResponse = function(submissions, fieldName) {
        var priorSubmission = submissions.filter(function(submission) {
            return submission[1] === fieldName;
        })[0];

        return (priorSubmission && priorSubmission[2]) || [];
    };

    return {
        getSurveyId: _getSurveyId,
        getSequenceLength: _getSequenceLength,
        getSequenceId: _getSequenceId,
        getCurrentSequence: _getCurrentSequence,
        getCurrentField: _getCurrentField,
        getFieldNavigation: _getFieldNavigation,
        getNextSurveyIndex: _getNextSurveyIndex,
        getPriorResponse: _getPriorResponse,
        getSurveysLength: _getSurveysLength
    };

})();

module.exports = surveyUtils;



// WEBPACK FOOTER //
// ./src/common/modules/survey/utils.js